<template>
    <div
        v-if  = "data"
        id    = "dms-viewer"
        style = "width: 100%; height: 100%; border-radius: 6px 0 6px 6px;"
    >
        <div
            :class = "border ? 'lm-border pa-3' : null"
            style  = "width: 100%; height: 100%"
        >
            <div
                v-if  = "isPdf || isExcel"
                style = "width: 100%; height: 100%"
            >
                <iframe
                    :src  = "data"
                    style = "width: 100%; height: 100%; border: none;"
                    :style="'border-radius:' + borderRadius + (topRight ? '; border-top-right-radius: 0;' : '')"
                >
                </iframe>
            </div>

            <p-dms-mail-viewer
                v-if   = "isMail"
                :mail  = "data"
                :popup = "popup"
                class  = "h-100"
            />

            <div
                v-if  = "isImage"
                style = "display: flex; width: 100%; height: 100%"
            >
                <img :src="data" alt="" style="margin: auto;max-width:100%;max-height:100%;border-style: solid;border-width: 1px;border-color: lightgrey;border-radius: 4px;">
            </div>
        </div>
    </div>
</template>

<script>

import Dms            from "@/modules/dms/common/service/Dms";
import PDmsMailViewer from "@/modules/dms/viewer/private/PDmsMailViewer.vue";

export default {
    name: "CDmsViewer",

    components: {
        PDmsMailViewer
    },

    props: {
        document: {

        },

        border: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        },

        margin: {

        },

        borderRadius: {
            required: false,
            default : () => {
                return "6px";
            }
        },

        topRight: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        }
    },

    data: () => ({
        type: null,
        data: null,
        showframe  : false,
        showmail   : false,
        mailContent: null,
        image      : null,
        popup      : false
    }),

    computed: {
        isMail () {
            return this.type && this.type === Dms.type.MAIL;
        },

        isExcel () {
            return this.type && this.type === Dms.type.EXCEL;
        },

        isPdf () {
            return this.type && this.type === Dms.type.PDF;
        },

        isImage () {
            return this.type && this.type === Dms.type.IMAGE;
        },
    },

    mounted() {
        this.load();
    },

    watch: {
        document() {
            this.load();
        }
    },

    methods: {
        setDocument (document, popup, success) {
            this.popup = popup;
            Dms.prepare(this, document, ((type, data) => {
                this.type = type ? type : null;
                this.data = type ? data : null;
                if (success) success ();
            }));
        },

        load () {
            this.setDocument(this.document, false)
        }
    }
}
</script>

<style>

</style>